// Number display/parse helpers (thousand separators).

// Display a number with thousand separators while keeping the decimals the user
// is typing (e.g. "26431.5" → "26,431.5"). Empty/invalid → ''.
export const formatThousands = (val) => {
  if (val === '' || val === null || val === undefined) return '';
  const s = String(val);
  const neg = s.trim().startsWith('-');
  const clean = s.replace(/[^0-9.]/g, '');
  // Keep a lone leading '-' visible while the user is mid-typing "-120".
  if (clean === '') return neg ? '-' : '';
  const dot = clean.indexOf('.');
  const intPart = dot === -1 ? clean : clean.slice(0, dot);
  const decPart = dot === -1 ? '' : clean.slice(dot); // includes the '.'
  const intFmt = (intPart || '0').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${neg ? '-' : ''}${intFmt}${decPart}`;
};

// Percent shown as a whole number ("70%"). Values can arrive lẻ — received_up_to
// được backend tính từ % of contract — hoặc là chuỗi nhập tay; chuỗi không phải
// số thì trả nguyên văn thay vì nuốt thành NaN.
export const formatPercent = (val) => {
  if (val === '' || val === null || val === undefined) return '';
  const num = Number(val);
  return Number.isFinite(num) ? `${Math.round(num)}%` : `${val}%`;
};

// Strip separators → the raw numeric string the form/API stores (one dot max).
// `allowNegative` preserves a single leading '-' (default off, so existing
// callers keep dropping any sign as before).
export const parseNumber = (str, allowNegative = false) => {
  if (str === '' || str === null || str === undefined) return '';
  const s = String(str);
  const sign = allowNegative && s.trim().startsWith('-') ? '-' : '';
  const clean = s.replace(/[^0-9.]/g, '');
  const firstDot = clean.indexOf('.');
  if (firstDot === -1) return clean === '' ? sign : sign + clean;
  return sign + clean.slice(0, firstDot + 1) + clean.slice(firstDot + 1).replace(/\./g, '');
};
